var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.333 20H2.667a1.59 1.59 0 0 1-1.6-1.579V5.79a.53.53 0 0 1 .533-.526.53.53 0 0 1 .533.526v12.632c0 .29.24.526.534.526h10.666a.53.53 0 0 0 .534-.526V5.79a.53.53 0 0 1 .533-.526.53.53 0 0 1 .533.526v12.632a1.59 1.59 0 0 1-1.6 1.579z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.467 6.316H.533A.53.53 0 0 1 0 5.789V3.684a1.59 1.59 0 0 1 1.6-1.579h12.8c.884 0 1.6.707 1.6 1.58v2.104a.53.53 0 0 1-.533.527zm-14.4-1.053h13.866V3.684a.53.53 0 0 0-.533-.526H1.6a.53.53 0 0 0-.533.526v1.58z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 3.158a.53.53 0 0 1-.533-.526V1.579a.53.53 0 0 0-.533-.526H6.933a.53.53 0 0 0-.533.526v1.053a.53.53 0 0 1-.533.526.53.53 0 0 1-.534-.526V1.579A1.59 1.59 0 0 1 6.933 0h2.134c.883 0 1.6.707 1.6 1.579v1.053a.53.53 0 0 1-.534.526zM5.867 16.842a.53.53 0 0 1-.534-.526V8.947a.53.53 0 0 1 .534-.526.53.53 0 0 1 .533.526v7.369a.53.53 0 0 1-.533.526zM10.133 16.842a.53.53 0 0 1-.533-.526V8.947a.53.53 0 0 1 .533-.526.53.53 0 0 1 .534.526v7.369a.53.53 0 0 1-.534.526z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon-delete.a5dece0882dfeaf0e29fc0fbd85e49b0.svg";
export { ForwardRef as ReactComponent };